module.exports = __webpack_public_path__ + "static/media/AOT.76b910f5.png";